import { render, staticRenderFns } from "./WeekGrid.vue?vue&type=template&id=412c5011&scoped=true"
import script from "./WeekGrid.vue?vue&type=script&lang=js"
export * from "./WeekGrid.vue?vue&type=script&lang=js"
import style0 from "./WeekGrid.vue?vue&type=style&index=0&id=412c5011&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c5011",
  null
  
)

export default component.exports